/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_UnverifiedInputs */

const en_fix_unverified = /** @type {(inputs: Fix_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not checked yet (≈)`)
};

const de_fix_unverified = /** @type {(inputs: Fix_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht geprüft (≈)`)
};

/**
* | output |
* | --- |
* | "Not checked yet (≈)" |
*
* @param {Fix_UnverifiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_unverified = /** @type {((inputs?: Fix_UnverifiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_UnverifiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_unverified(inputs)
	return en_fix_unverified(inputs)
});